<template>
  <div :class="[`x1-72 poppins-bold-black-15px`, className || ``]">
    <div class="number-10">{{ number }}</div>
    <div class="group-234-17" :style="{ 'background-image': 'url(' + group234 + ')' }"></div>
    <div class="text-501">{{ text524 }}</div>
    <div class="text-500">100,0</div>
  </div>
</template>

<script>
export default {
  name: "X182",
  props: ["number", "group234", "text524", "className"],
};
</script>

<style>
.x1-72 {
  display: flex;
  margin-left: 36px;
  width: 346px;
}

.number-10 {
  height: 23px;
  letter-spacing: 0.3px;
  line-height: normal;
  margin-top: 18px;
  width: 6px;
}

.group-234-17 {
  aspect-ratio: 1;
  background-color: var(--alto);
  background-position: 50% 50%;
  background-size: cover;
  border-radius: 60px;
  height: 55px;
  margin-left: 18px;
  width: 55px;
}

.text-501 {
  height: 23px;
  letter-spacing: 0.3px;
  line-height: normal;
  margin-left: 6px;
  margin-top: 18px;
  width: 184px;
}

.text-500 {
  height: 23px;
  letter-spacing: 0.3px;
  line-height: normal;
  margin-left: 30px;
  margin-top: 18px;
  width: 41px;
}

.x1-72.x2-21,
.x1-72.x2-22 {
  margin-top: 1.5px;
}

.x1-72.x2-21 .number-10,
.x1-72.x2-22 .number-10,
.x1-72.x2-23 .number-10,
.x1-72.x2-24 .number-10,
.x1-72.x2-25 .number-10,
.x1-72.x2-26 .number-10 {
  width: 9px;
}

.x1-72.x2-21 .group-234-17,
.x1-72.x2-22 .group-234-17,
.x1-72.x2-23 .group-234-17,
.x1-72.x2-24 .group-234-17,
.x1-72.x2-25 .group-234-17,
.x1-72.x2-26 .group-234-17 {
  margin-left: 15px;
}

.x1-72.x2-21 .text-501,
.x1-72.x2-22 .text-501,
.x1-72.x2-23 .text-501,
.x1-72.x2-24 .text-501,
.x1-72.x2-25 .text-501,
.x1-72.x2-26 .text-501 {
  width: 104px;
}

.x1-72.x2-21 .text-500,
.x1-72.x2-22 .text-500,
.x1-72.x2-23 .text-500,
.x1-72.x2-24 .text-500,
.x1-72.x2-25 .text-500,
.x1-72.x2-26 .text-500 {
  margin-left: 110px;
}

.x1-72.x1-74,
.x1-72.x1-75,
.x1-72.x1-76,
.x1-72.x1-77 {
  margin-left: 26px;
}

.x1-72.x2-23,
.x1-72.x2-24,
.x1-72.x2-25,
.x1-72.x2-26 {
  margin-left: 26px;
  margin-top: 1.5px;
}
</style>
